import React from 'react';
import { Equal, SkipForward } from 'lucide-react';

interface RankingControlsProps {
  onTie: () => void;
  onSkip: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

const RankingControls: React.FC<RankingControlsProps> = ({ 
  onTie, 
  onSkip,
  isLoading = false,
  disabled = false
}) => {
  return (
    <div className="grid grid-cols-2 gap-2 sm:gap-4">
      <button
        onClick={onTie}
        disabled={isLoading || disabled}
        className="flex items-center justify-center gap-1 px-2 py-2.5 bg-brand/10 text-brand hover:bg-brand/20 rounded-lg transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 text-sm sm:text-base"
      >
        <Equal className="w-4 h-4" />
        <span>Tie</span>
      </button>
      <button
        onClick={onSkip}
        disabled={isLoading || disabled}
        className="flex items-center justify-center gap-1 px-2 py-2.5 bg-background border border-gray-800 rounded-lg text-content-secondary hover:text-brand hover:border-brand transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 text-sm sm:text-base"
      >
        <SkipForward className="w-4 h-4" />
        <span>Skip</span>
      </button>
    </div>
  );
};

export default RankingControls;
